import styled from "styled-components";

const Image = styled.img`
  height: 500px;
  width: 100%;
  object-fit: cover;
  margin: auto 0;
`;

const ImageStyle = styled.img`
  width: 200px;
  height: 200px;
  border-color: "brown";
  border: ${(props) => props.border ? "5px solid brown" : "0px" };
  object-fit: cover;
`;

const ListTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

const ListHeaderTitle = styled.div`
  font-size: 50pt;
  color: black;
  padding: 20px;
`;

const ListSubTitle = styled.div`
  font-size: 20pt;
  color: gray;
  padding: 20px;
`;

const TopPadding = styled.div`
  padding: 20px 0;
`;

const TitleOrder = styled.div`
  color: gray;
  font-size: 16px;
`;

const DateStyle = styled.div`
  margin: auto 0;
  font-weight: normal;
  font-size: 16px;
`;

const TitleProduct = styled.div`
  margin: auto 0;
  color: gray;
  font-size: 16px;
`;

const SubTitleProduct = styled.div`
  margin: auto 0;
  font-weight: bold;
  color: gray;
  font-size: 14px;
`;

const TagPrice = styled.div`
  margin: auto 0;
  font-weight: normal;
  color: red;
  font-size: 14px;
`;

const TotalPrice = styled.div`
  margin: auto 0;
  font-weight: normal;
  color: gray;
  font-size: 16px;
`;

const Button = styled.button`
  /* Adapt the colors based on primary prop */
  background: ${props => props.primary ? "black" : "white"};
  color: ${props => props.primary ? "white" : "black"};

  font-size: 2em;
  padding: 0.25em 1em;
  border: 2px solid black;
  border-radius: 8px;
`;

const Container = styled.div`
  padding: 0 0 5rem 0;
`;

const MiddleContainer = styled.div`
  position: absolute;
  border-radius: 16px;
  border-style: solid;
  border-width: thin;
  border-color: gray;
  background-color: white;
  width: 300px;
  height: 300px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const ButtonQuantity = styled.button`
  /* Adapt the colors based on primary prop */
  background: ${props => props.primary ? "gray" : "white"};
  color: ${props => props.primary ? "white" : "gray"};

  font-size: 1.2em;
  padding: 0.25em 0.5em;
  border: 2px solid gray;
  border-radius: 8px;
  height: 35px;
  width: 35px;
  text-align: center;
`;

const textQuantity = styled.div`
  font-weight: normal;
  color: gray;
`;


export { Image, ListTitle, ListHeaderTitle, ListSubTitle, TopPadding, ImageStyle, TitleOrder, DateStyle, TitleProduct,
  SubTitleProduct, TagPrice, TotalPrice, Button, Container, MiddleContainer, ButtonQuantity, textQuantity };
